var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15419 8H22.8465C25.1428 8 27.0004 9.82192 27.0004 12.0591V19.9408C27.0004 22.178 25.1428 23.9999 22.8465 23.9999H9.15419C6.85789 23.9999 5.00037 22.178 5.00037 19.9408V12.0591C5.00037 9.82192 6.85789 8 9.15419 8ZM6.40067 12.5038H25.6001V12.0591C25.6001 10.5693 24.3608 9.36241 22.8465 9.36241H9.15419C7.63994 9.36241 6.40067 10.5693 6.40067 12.0591V12.5038ZM25.6001 13.8663H6.40067V19.9408C6.40067 21.4306 7.63994 22.6375 9.15419 22.6375H22.8465C24.3608 22.6375 25.6001 21.4306 25.6001 19.9408V13.8663Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88732 18.4004H14.1127C14.5968 18.4004 15 18.7639 15 19.2004C15 19.6369 14.5968 20.0004 14.1127 20.0004H9.88732C9.4032 20.0004 9 19.6369 9 19.2004C9 18.7639 9.4032 18.4004 9.88732 18.4004Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.fe016fd5.svg";
export { ForwardRef as ReactComponent };